import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import {
  Decorator,
  SwitchQuestion,
  LinkQuestion,
  TagsQuestion,
  QuestionBase,
  EntityQuestion,
  HiddenQuestion
} from 'core/components/forms';
import { ClientsService } from 'core/services/clients.service';
import { ProfileService } from 'core/services/profile.service';
import { Location } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class StudentsInviteQuestionsService {
  protected questions: QuestionBase<any>[];

  userRole;
  constructor(
    public clientsService: ClientsService,
    public profileService: ProfileService,
    private location: Location,
    public translate: TranslateService
  ) {
    profileService.getLoggedUserRole$().subscribe((userRole) => (this.userRole = userRole));
  }

  getQuestions(params: any = {}) {
    const { client } = params;
    let selfRegistrationUrl = '';
    if (client) {
      const { lang, name, uuid } = client;
      const enrollmentObject = {
        clientName: name,
        lang,
        uuid: uuid
      };
      const token = btoa(encodeURI(JSON.stringify(enrollmentObject)));
      selfRegistrationUrl = `${environment.SERVICES_URL}/enrollment?token=${token}`;
    }
    const questions = [
      new Decorator({
        html: `<span>${this.translate.instant('groups.enrollment.self.info')}</span>`,
        valueClass: 'gl-forms__text'
      }),
      new SwitchQuestion({
        key: 'enabled',
        class: 'gl-forms__position--topRight',
        switchOffLabel: 'nouns.no',
        switchOnLabel: 'nouns.yes',
        value: client && client.selfRegistration ? !!client.selfRegistration.enabled : false,
        eventHandlers: {
          onChange: (checked) => {
            const clipboardQuestion = questions.find((question) => question.key && question.key === 'copyClipboard');
            const validDomainsdQuestion = questions.find((question) => question.key && question.key === 'validDomains');
            clipboardQuestion.setDisabled(!checked);
            validDomainsdQuestion.setDisabled(!checked);
          }
        }
      }),

      new LinkQuestion({
        key: 'copyClipboard',
        class: 'col-1',
        value: client && client.selfRegistration && !!client.selfRegistration.enabled ? selfRegistrationUrl : ''
      }),
      new TagsQuestion({
        key: 'validDomains',
        label: 'nouns.validDomains',
        class: 'col-1',
        value:
          client && client.selfRegistration && client.selfRegistration.validDomains
            ? client.selfRegistration.validDomains.split(',')
            : []
      })
    ];
    return questions;
  }

  getClientQuestions(client?: any) {
    const clientQuestion =
      this.userRole.scope === 'client'
        ? new HiddenQuestion({
            key: 'clientId',
            value: client.id,
            validators: { required: true },
            order: 100
          })
        : new EntityQuestion({
            key: 'clientId',
            label: 'nouns.client',
            class: 'col-1',
            value: client ? client.id : null,
            entity: client,
            editable: !client,
            validators: { required: true },
            dataProvider: this.clientsService,
            entityOptions: { filters: { 'scorm.enabled': 'false' } },
            order: 1
          });
    const questions: QuestionBase<any>[] = [clientQuestion];
    return questions;
  }

  goBack() {
    this.location.back();
  }
}
